import { UnknownError } from '../types';
export var handleError = function (error) {
    return error instanceof Error ? error : new UnknownError(error);
};
